import classNames from "components/ui/classNames";
import type { HTMLProps } from "react";

export default function ContentContainerBox({ className, ...props }: HTMLProps<HTMLDivElement>) {
  return (
    <div
      {...props}
      className={classNames(
        "relative rounded-xl border bg-white px-4 py-6 sm:px-6",
        "ring-4 ring-slate-100 ring-offset-1 ring-offset-slate-100",
        "dark:ring-1 dark:ring-slate-950 dark:ring-offset-2 dark:ring-offset-slate-900",
        "dark:border-transparent dark:bg-slate-900",
        className,
      )}
    />
  );
}
